import { atom, selector } from 'recoil'
import {
  ConfirmStyleType, FooterStyleType,
  InsertStyleType,
  JoinTerms,
  MvmoType,
  PartnerListType,
  TermsStyleType,
  UiData, VerifyStyleType
} from 'src/types/type'

const TelTypeState = atom<number>({
  key: 'TelTypeState',
  default: 0
})
const TelNumState = atom<string>({
  key: 'TelNumState',
  default: ''
})
const TimeoutState = atom<number>({
  key: 'TimeoutState',
  default: 0
})
const TransIdState = atom<string>({
  key: 'TransIdState',
  default: ''
})
const authKeyState = atom<string | undefined>({
  key: 'authKeyState',
  default: undefined
})
const CertCheckState = atom<boolean>({
  key: 'CertCheckState',
  default: false
})
const MvmoTermsState = atom<MvmoType>({
  key: 'MvmoTermsState',
  default: {
    Terms: '',
    TermsTitle: '',
  }
})
const JoinTermsValue = atom<number[]>({
  key: 'JoinTermsValue',
  default: [0, 0, 0, 0, 0, 0, 0, 0, 0]
})
export const MvnoCheckValue = atom<boolean>({
  key: 'MvnoCheckValue',
  default: false
})
const VulnerableCheckState = atom<boolean>({
  key: 'VulnerableCheckState',
  default: false,
})
const JoinTermsIdx = atom<number>({
  key: 'JoinTermsIdx',
  default: 0
})
const AllCheckStatus = atom<boolean>({
  key: 'AllCheckStatus',
  default: false
})
const CertNumState = atom<string>({
  key: 'CertNumState',
  default: ''
})

const PartnerListData = atom<PartnerListType>({
  key: 'PartnerData',
  default: {
    ButtonMsgAfter: '',
    ButtonMsgBefore: '',
    DelayRewardMin: 0,
    FeeCost: 0,
    FeeRate: 0,
    FeeType: 0,
    FontColor: '',
    FontSize: '',
    Image1: '',
    Image2: '',
    FooterImage: '',
    JoinURL: '',
    NotiContent: '',
    PCODE: '',
    PGroup: '',
    PName: '',
    PSKey: '',
    RewardAPI: '',
    RewardURI: '',
    UiData: '',
    UiType: '',
    SKTJoin: 'Y',
    KTJoin: 'Y',
    LGUPJoin: 'Y',
    JoinBlockMsg: '',
  }
})
const TermsListData = atom<JoinTerms[]>({
  key: 'TermsListData',
  default: [
    // SKT
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    },
    // KT
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    },
    // LGUP
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    }
  ]
})

const TermsSelector = selector({
  key: 'TermsSelector',
  get: ({ get }) => get(TermsListData)?.[get(TelTypeState)],
})

// 필수약관 동의 여부
export const IsAgreeAllRequiredTermsSelector = selector({
  key: 'IsAgreeAllRequiredTermsSelector',
  get: ({ get }) => get(TermsSelector)?.Terms
    .filter((terms) => terms.Required === 1 && terms.Order !== undefined)
    .every((terms) => get(JoinTermsValue)[terms.Order! - 1] === 1) ?? false,
})

const RecoilStateList = selector({
  key: 'RecoilStateList',
  get: ({ get }) => {
    return {
      TelType: get(TelTypeState),
      PhoneNum: get(TelNumState),
      Timeout: get(TimeoutState),
      TransId: get(TransIdState),
      authKeyValue: get(authKeyState),
      CertCheck: get(CertCheckState),
      VulnerableCheck: get(VulnerableCheckState),
      TermsList: get(TermsListData),
      TermsData: get(TermsSelector),
      termsAgree: get(JoinTermsValue),
      AllTermsAgree: get(AllCheckStatus),
      CertNum: get(CertNumState),
      isAgreeAllRequiredTerms: get(IsAgreeAllRequiredTermsSelector),
    }
  }
})
const uiData = atom<UiData>({
  key: 'uiData',
  default: {
    layoutsInsert: {
      mainBg: '#fff',
      certs: {
        type: '',
        borderColor: '#fff',
        backgroundColor: '#fff'
      },
      agency: {
        shape: '',
        actColor: '#fff'
      }
    },
    layoutsConfirm: {
      confirmHover: false,
      submitBtn: {
        borderRadius: 'none',
        fontSize: '13.5px',
        letterSpacing: '-1px',
        backgroundColor: '#fff',
        fontColor: '#fff',
        fontWeight: 400
      }
    },
    layoutsFooter: {
      color: '#fff',
      backgroundColor: '#fff'
    },
    layoutsTerms: {
      direction: '',
      shape: '',
      actColor: '#fff',
      borderRadius: 'none',
    },
    layoutsVerify: {
      verifyDir: '',
      cashSpace: '0px',
      verifyBtn: {
        borderRadius: 'none',
        fontSize: '13.5px',
        letterSpacing: '0',
        backgroundColor: '#fff',
        fontColor: '#fff',
        fontWeight: 400
      },
      cancelBtn: {
        borderRadius: 'none',
        fontSize: '13.5px',
        letterSpacing: '0',
        backgroundColor: '#fff',
        fontColor: '#fff',
        fontWeight: 400
      }
    }
  }
})
const uiInsertsStyle = selector<InsertStyleType>({
  key: 'uiCertsStyle',
  get: ({ get }) => get(uiData).layoutsInsert
})
const uiConfirmStyle = selector<ConfirmStyleType>({
  key: 'uiConfirmStyle',
  get: ({ get }) => get(uiData).layoutsConfirm
})
const uiTermsStyle = selector<TermsStyleType>({
  key: 'uiTermsStyle',
  get: ({ get }) => get(uiData).layoutsTerms
})
const uiVerifyStyle = selector<VerifyStyleType>({
  key: 'uiVerifyStyle',
  get: ({ get }) => get(uiData).layoutsVerify
})
const uiFooterStyle = selector<FooterStyleType>({
  key: 'uiFooterStyle',
  get: ({ get }) => get(uiData).layoutsFooter
})
const termsModalOpen = atom<boolean>({
  key: 'termsModalOpen',
  default: false
})
export {
  TelTypeState,
  TelNumState,
  TimeoutState,
  TransIdState,
  authKeyState,
  CertCheckState,
  VulnerableCheckState,
  JoinTermsValue,
  TermsListData,
  AllCheckStatus,
  JoinTermsIdx,
  CertNumState,
  PartnerListData,
  RecoilStateList,
  uiData,
  uiConfirmStyle,
  uiFooterStyle,
  uiInsertsStyle,
  uiTermsStyle,
  uiVerifyStyle,
  termsModalOpen,
  MvmoTermsState
}
